export default __webpack_public_path__ + "media/music/5ec6205f4fb25940fd322258a222c0c7.mp3";